import { UnauthorizedBaseView } from 'General/Views/Static/Unauthorized/UnauthorizedBaseView';

export class UnauthorizedView extends UnauthorizedBaseView{ }